import { DisplayMode } from '@flywire/internal-components/model';

import { warn } from '../../logger';
import { SDKError } from '../error';

export type CreateIframeOptions = {
  src: string;
  displayMode: DisplayMode;
  containerId?: string;
  title?: string;
  width?: string;
  height?: string;
  containerErrorKey?:
    | 'paymentElementContainerNotPresent'
    | 'documentCollectorElementContainerNotPresent'
    | 'lrsElementContainerNotPresent'
    | 'paymentMethodSelectorElementContainerNotPresent'
    | 'recipientFieldsElementContainerNotPresent';
};

export const createIframe = ({
  displayMode,
  containerId,
  src,
  title = 'Flywire Payment Element',
  containerErrorKey = 'paymentElementContainerNotPresent'
}: CreateIframeOptions) => {
  if (displayMode === 'container' && !containerId) {
    throw new SDKError(containerErrorKey);
  }

  if (displayMode === 'container' && containerId) {
    const presentContainer = document.getElementById(containerId);
    if (!presentContainer) {
      throw new SDKError(containerErrorKey);
    }

    const iframe = createIframeElement(src, title);
    presentContainer.appendChild(iframe);
    return { iframe, container: presentContainer };
  }

  const container = createDialogContainer();
  warn('overridingPaymentElementContainer', {
    message: 'A new dialog element has been added to the document body'
  });
  const iframe = createIframeElement(src, title);
  container.appendChild(iframe);
  return { iframe, container };
};

const createDialogContainer = () => {
  const dialog = document.createElement('dialog');
  dialog.style.position = 'fixed';
  dialog.style.inset = '0';
  dialog.style.width = '100%';
  dialog.style.height = '100%';
  dialog.style.maxWidth = '100%';
  dialog.style.maxHeight = '100%';
  dialog.style.margin = '0';
  dialog.style.padding = '0';
  dialog.style.border = '0';
  dialog.style.background = 'rgba(41, 51, 60, 0.9)';
  dialog.style.overflow = 'hidden';
  dialog.addEventListener('cancel', e => e.preventDefault());
  document.body.appendChild(dialog);
  dialog.showModal();
  return dialog;
};

const createIframeElement = (src: string, title: string) => {
  const iframe = document.createElement('iframe');
  iframe.setAttribute('data-testid', 'checkout-iframe');

  iframe.style.width = '100%';
  iframe.style.height = '100%';
  iframe.style.border = 'none';

  iframe.src = src;
  iframe.allow = 'clipboard-write';

  iframe.title = title;
  return iframe;
};
